import type { ComponentType, PropsWithChildren } from 'react'
import { useMemo } from 'react'

import { type Lesson, useCurriculumQuery } from '@segment/api/routes/growthMasters/queries'

import type { FiltersState } from '@segment/api/types/common'

import type { NextPageTriggerProps } from '@segment/utils/useNextPageTrigger'
import useNextPageTrigger from '@segment/utils/useNextPageTrigger'

export const useCurriculumGrid = (
  filtersState: FiltersState,
  triggerComponent?: ComponentType<PropsWithChildren<NextPageTriggerProps>>
) => {
  const { data, isLoading, hasNextPage, fetchNextPage, error, isFetchingNextPage } = useCurriculumQuery({
    args: [{ ...filtersState }],
  })

  const pages: Lesson[] = useMemo(
    () => data?.pages?.flatMap((collection) => collection?.items ?? []) ?? [],
    [data?.pages]
  )

  const nextPageTrigger = useNextPageTrigger({
    isLoading,
    totalDownloadedPages: data?.pages.length ?? -1,
    hasNextPage,
    error,
    async onNextPage() {
      await fetchNextPage()
    },
    loadMargin: `0%`,
    NextPageTrigger: triggerComponent,
  })

  return { pages, isLoading, nextPageTrigger, isFetchingNextPage, hasNextPage }
}
